<template>
  <iframe
    :src="video"
    ref="player"
    title="YouTube video player"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen
    frameborder="0"
    width="100%"
    height="100%"
    @mousemove="onMousemove"
    @mouseout="omMouseout"
  />
</template>

<script>
import $ from 'jquery'
import { ref } from 'vue'
import YouTubePlayer from 'youtube-player'
import { metrikaEvents } from '../../../../../services/metrika'

export default {
  name: 'YoutubePlayer',
  props: {
    isSlider: Boolean,
    src: String,
  },
  computed: {
    video() {
      const youtubeVideoId = this.getYoutubeVideoId(this.src)
      return `https://www.youtube.com/embed/${youtubeVideoId}?enablejsapi=1`
    },
  },
  setup() {
    const isPlay = ref(false)
    const insideOfCarousel = ref(false)

    return {
      isPlay,
      insideOfCarousel,
    }
  },
  mounted() {
    const youtubePlayer = YouTubePlayer(this.$refs.player.id)
    youtubePlayer.on('stateChange', this.onYoutubePlayerStateChange)
  },
  methods: {
    getYoutubeVideoId(link) {
      if (!link) return ''
      if (link.includes('shorts')) {
        const url = new URL(link)
        const splittedPathname = url.pathname.split('/')
        return splittedPathname[splittedPathname.length - 1]
      }
      if (link.includes('youtu.be')) {
        return link.split('youtu.be/')[1] || ''
      }

      const youtubeLink = link.split('&')[0]
      return youtubeLink.includes('v=') ? youtubeLink.split('v=')[1] : ''
    },
    onYoutubePlayerStateChange({ data }) {
      const states = {
        1: 'play',
        2: 'stop',
      }
      if (states[data]) {
        metrikaEvents.videoEvent(states[data])
      }

      if (!this.isSlider) {
        return
      }
      const { player } = this.$refs

      const $carouselWrapper = $(player).closest('.carousel-inner')
      const $previousControl = $carouselWrapper.find('.carousel-control-prev')
      const $nextControl = $carouselWrapper.find('.carousel-control-next')
      const $indicatorsControl = $carouselWrapper.find('.carousel-indicators')

      switch (data) {
        case 1:
          $previousControl.hide()
          $nextControl.hide()
          $indicatorsControl.hide()
          this.isPlay = true
          this.toCycle()
          break
        case 0:
        case 2:
          $previousControl.show()
          $nextControl.show()
          $indicatorsControl.show()
          this.isPlay = false
          this.toCycle()
          break
      }
    },
    toCycle() {
      const $carousel = $('.carousel')

      if (this.isPlay) {
        $carousel.carousel('pause')
        return
      }
      if (!this.isPlay && this.insideOfCarousel) {
        $carousel.carousel('pause')
        return
      }
      $carousel.carousel('cycle')
    },
    onMousemove() {
      if (!this.isSlider) {
        return
      }
      this.insideOfCarousel = true
      this.toCycle()
    },
    omMouseout() {
      if (!this.isSlider) {
        return
      }
      this.insideOfCarousel = false
      this.toCycle()
    },
  },
}
</script>
